import instagram from "assets/icons/footer/instagram.svg";
import vnLabLogo from "assets/icons/footer/VN_logo.svg";
import { Fragment, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
const BottomNavbar = () => {
  const location = useLocation();
  const [isHidden, setIsHidden] = useState(true);

  useEffect(() => {
    if (location.pathname === "/") {
      setIsHidden(true);
      return;
    }
    if (location.pathname === "/intro") {
      setIsHidden(true);
      return;
    }
    setIsHidden(false);
  }, [location, setIsHidden]);
  return (
    <Fragment>
      {!isHidden && (
        <div className="d-flex flex-row position-fixed start-0 bottom-0 px-4 m-3 pb-1 z-index-11">
          <a
            target={"_blank"}
            href="http://vnlab.filmschool.lodz.pl"
            className="text-white text-decoration-none me-4"
            rel="noreferrer"
          >
            <img src={vnLabLogo} style={{ height: "16px" }} alt="VN_logo" />
          </a>
          <a
            target={"_blank"}
            href="https://www.instagram.com/tarta_kolektyw/"
            className="text-white text-decoration-none ms-3"
            rel="noreferrer"
          >
            <img
              src={instagram}
              style={{ height: "22px" }}
              alt="VN lab instagram"
            />
          </a>
        </div>
      )}
    </Fragment>
  );
};

export default BottomNavbar;
